import { normalizeTableCellEntity, TableCellEntity } from '../TableCell';

import { TableRowEntity, TableRowEntityApi } from './entity';

export const normalizeTableRowEntity = (
  raw: TableRowEntityApi
): TableRowEntity => {
  return {
    view: raw.view,
    rowId: raw.row_id,
    columns: raw.columns.reduce((acc, curr) => {
      return { ...acc, [curr.field_id]: normalizeTableCellEntity(curr) };
    }, {} as Record<string, TableCellEntity>),
  };
};
